import type {
  GetMembersOrdersByOrderIdResponse,
  GetMembersPlacesByPlaceIdResponse,
  GetMembersPlacesResponse,
  GetOrdersListItem,
  GetOrdersStatusesResponse,
} from "@birdwatch/client";

export enum HomeTab {
  ACTIVE = "active",
  FUTURE = "future",
}

export enum ListTab {
  TODO = "todo",
  IN_PROGRESS = "in-progress",
  COMPLETED = "completed",
}

/** One of the member's places from GET /api/v5/members/places (`useGetMembersPlaces`). */
export type MyPlaceListItem = GetMembersPlacesResponse[number];

/** Member place detail from GET /api/v5/members/places/{placeId} (`useGetMembersPlacesByPlaceId`). */
export type PlaceDetail = GetMembersPlacesByPlaceIdResponse;

/** Member place managers may include `avatarUrl` at runtime; OpenAPI may omit it. */
export type Manager = NonNullable<
  NonNullable<GetMembersPlacesByPlaceIdResponse["managers"]>[number]
> & { avatarUrl?: string | null };

export type Sponsor = NonNullable<
  NonNullable<GetMembersPlacesByPlaceIdResponse["sponsors"]>[number]
> & { avatarUrl?: string | null };

export type OrderStatusDetail = GetOrdersStatusesResponse[number];

export type { GetOrdersListItem as OrderListItem };

/**
 * Member order detail from `GET /api/v5/members/orders/{orderId}`
 * (`useGetMembersOrdersByOrderId`). `status` may include `customerLabel` when
 * resolved from statuses.
 */
export type OrderDetail = GetMembersOrdersByOrderIdResponse & {
  status?: OrderStatusDetail | null;
};

/**
 * One of an order's visits from the member order detail, tagged with the order it
 * belongs to (the detail nests visits under the order, so the row itself has no `orderId`).
 */
export type OrderVisit = GetMembersOrdersByOrderIdResponse["visits"][number] & {
  orderId: string;
};

/**
 * Member order attachment from `GET /api/v5/members/orders/{orderId}?includes=attachments`
 * (`useGetMembersOrdersByOrderId`) — attachments ride along on the order detail
 * response instead of a separate fetch.
 */
export type OrderAttachment = NonNullable<
  GetMembersOrdersByOrderIdResponse["attachments"]
>[number];
